import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';
import { MENU_WIDTH } from './constants';

type Props = {
  children?: ReactNode;
};

const EmptyListLabels = ({ children }: Props) => {
  const intl = useIntl();
  return (
    <Stack
      sx={{
        pt: 2,
        minHeight: 'inherit',
        textAlign: 'center',
        maxWidth: MENU_WIDTH,
      }}
      alignItems="center"
    >
      <Typography sx={{ fontWeight: 700 }} px={2}>
        {intl.formatMessage({
          id: 'components.labels.labelsFiltering.emptyList',
        })}
      </Typography>
      <Typography variant="body2" color="text.disabled" px={2}>
        {intl.formatMessage({
          id: 'components.labels.labelsFiltering.emptyListDescription',
        })}
      </Typography>
      {children}
    </Stack>
  );
};

export { EmptyListLabels };
